//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HouseItem from '@/components/business/house_item'
export default {
    components: {
        HouseItem
    },
    props: {
        title: String,
        link: String,
        data: Array
    },
}
